module.exports = __webpack_public_path__ + "img/kyc-guid.aca11707.png";